module.exports = ($uibModalInstance, $interval, settings, Api, type, projectId, showDownloadButton, forExternalSystem, $scope, $window) ->
  intervalPromise = undefined
  docId = 0
  $scope.type = type
  $scope.projectId = projectId
  $scope.showDownloadButton = showDownloadButton
  $scope.code = "Initializing"
  $scope.forExternalSystem = forExternalSystem

  refreshDoc = () ->
    Api.ProjectExports.get(id: docId).$promise
      .then (doc) ->
        $scope.code = doc.phase.code
        if(doc.phase.code == 'done')
          $scope.downloadUrl = doc[type].download_url
          $interval.cancel(intervalPromise)
          if $scope.showDownloadButton
            $window.location.assign(doc[type].download_url)


  Api.ProjectExports.save(project: $scope.projectId, pdf_type: type, for_external_system: $scope.forExternalSystem).$promise
    .then (doc) ->
      if(doc.phase.code == 'done')
        $scope.downloadUrl = doc[type].download_url
        $window.open(doc[type].download_url)
      else
        docId = doc.id
        intervalPromise = $interval(refreshDoc, settings.DOCUMENT_POLLING_INTERVAL)
        refreshDoc()

  $scope.shouldShowDownloadButton = () ->
    return $scope.downloadUrl && $scope.showDownloadButton

  $scope.cancel = () ->
    $uibModalInstance.dismiss('cancel')
